const socketNames = detail => [
  ...new Set(
    (detail.headlight_categories || [])
      .map(category => category.name)
      .filter(Boolean)
  ),
]

const sameSockets = (left, right) =>
  left.length === right.length && left.every(name => right.includes(name))

export function socketTableRows(blocks) {
  return (blocks || [])
    .map(block => {
      const versions = (block.details || [])
        .map(detail => ({
          id: detail.id,
          name: detail.name,
          sockets: socketNames(detail),
        }))
        .filter(version => version.sockets.length)

      if (!versions.length) return null

      const single = versions.every(version =>
        sameSockets(version.sockets, versions[0].sockets)
      )

      return {
        key: block.headlight_type.id,
        type: block.headlight_type,
        versions: single
          ? [{ id: versions[0].id, name: null, sockets: versions[0].sockets }]
          : versions,
      }
    })
    .filter(Boolean)
}

export function heroProductIds(blocks) {
  return new Set(
    (blocks || [])
      .flatMap(block => (block.details || []).map(d => d.hero_product_id))
      .filter(Boolean)
  )
}
